import styled from 'styled-components';

import {
  scale150,
  spaceL,
  xdlColorHoverSecondary,
  xdlColorSelected,
  xdlColorText,
  xdlColorTextInvert,
} from '@xingternal/tokens';

type InnerComponentProps = {
  $current?: boolean;
  $truncated?: boolean;
};

export const InnerElement = styled.a<InnerComponentProps>`
  align-items: center;
  color: ${({ $current }) => ($current ? xdlColorTextInvert : xdlColorText)};
  display: flex;
  font-size: ${spaceL};
  font-weight: bold;
  height: ${scale150};
  justify-content: center;
  width: ${scale150};

  cursor: ${({ $current, $truncated }) => ($truncated ? 'default' : $current ? 'auto' : 'pointer')};
  user-select: ${({ $truncated }) => ($truncated ? 'none' : 'auto')};
  text-decoration: ${({ $current }) => ($current ? 'none' : 'auto')};
  border-radius: ${({ $current }) => ($current ? '50%' : 'auto')};
  background-color: ${({ $current }) => ($current ? xdlColorSelected : 'unset')};

  &:hover,
  &:focus {
    color: ${({ $current }) => ($current ? xdlColorTextInvert : xdlColorText)};
    background-color: ${({ $current, $truncated }) =>
      $truncated ? 'transparent' : $current ? xdlColorSelected : xdlColorHoverSecondary};
    text-decoration: none;
    border-radius: 50%;
  }
`;
